/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import * as global from "../../js/global" ;
    import * as helper from "../../js/helper";
    const __vue_script__ ={
        components: {
        },
		name:'property_features_component',
        props: {
            property_json: {
                type: String,
            },
            property_data: {
                type: Object,
            },
        },
		data() {
			return {
                global,
                helper,
                frappe,
                is_loading: false,
                property: null,
			};
		},
        mounted(){
            if(this.property_json != undefined)
                this.property = JSON.parse(this.property_json);
            else
                this.property = this.property_data;
        },
		methods: {
			check_enabled: function(field){
				if (this.property.property_type=="")
					return false;
				return this.enabled_fields.includes(field);
			},
		},
		computed:{
            enabled_fields(){
                var fields = global.property_constants.property_types[this.property.property_type];
                global.property_constants.remove_field[this.property.ad_type].forEach(field => {
                    const index = fields.indexOf(field);
                    if (index > -1) { // only splice array when item is found
                        fields.splice(index, 1); // 2nd parameter means remove one item only
                    }
                });
                if(this.is_child){
                    global.property_constants.remove_child_field.forEach(field => {
                        const index = fields.indexOf(field);
                        if (index > -1) { // only splice array when item is found
                            fields.splice(index, 1); // 2nd parameter means remove one item only
                        }
                    });
                }
                return fields;
            }
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.property
    ? _c(
        "ul",
        {
          staticClass:
            "features g-0 d-flex justify-content-start gap-1 mb-2 pt-1"
        },
        [
          _vm.property["images"] && _vm.property["images"].length > 0
            ? _c("li", { staticClass: "feature badge bg-light text-dark" }, [
                _c("i", { staticClass: "fa-solid fa-lg fa-images" }),
                _vm._v(
                  " " + _vm._s(_vm.property["images"].length) + "\n        "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("size") && _vm.property.size > 0
            ? _c(
                "li",
                {
                  staticClass: "feature badge bg-light text-dark d-flex",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("Size"),
                    "data-bs-trigger": "hover"
                  }
                },
                [
                  _c("i", { staticClass: "ri-custom-size ri-xl mx-1" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "d-block" }, [
                    _vm._v(
                      _vm._s(
                        _vm.helper.t("{0} sq.m.", [
                          _vm.property["size"].toFixed(2).replace(/[.,]00$/, "")
                        ])
                      )
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("no_bed") && _vm.property.no_bed > 0
            ? _c(
                "li",
                {
                  staticClass: "feature badge bg-light text-dark",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("Bedrooms"),
                    "data-bs-trigger": "hover"
                  }
                },
                [
                  _c("i", { staticClass: "fa-solid fa-lg fa-door-closed" }),
                  _vm._v(" " + _vm._s(_vm.property.no_bed) + "\n        ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("no_living") && _vm.property.no_living > 0
            ? _c(
                "li",
                {
                  staticClass: "feature badge bg-light text-dark",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("Livingrooms"),
                    "data-bs-trigger": "hover"
                  }
                },
                [
                  _c("i", { staticClass: "fa-solid fa-lg fa-tv" }),
                  _vm._v(" " + _vm._s(_vm.property.no_living) + "\n        ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("no_bath") && _vm.property.no_bath > 0
            ? _c(
                "li",
                {
                  staticClass: "feature badge bg-light text-dark",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("Bathrooms"),
                    "data-bs-trigger": "hover"
                  }
                },
                [
                  _c("i", { staticClass: "fa-solid fa-lg fa-bath" }),
                  _vm._v(" " + _vm._s(_vm.property.no_bath) + "\n        ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("is_water") && _vm.property.is_water
            ? _c(
                "li",
                {
                  staticClass: "feature badge bg-light text-dark",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("is_water"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-lg fa-droplet" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("is_power") && _vm.property.is_power
            ? _c(
                "li",
                {
                  staticClass: "feature badge bg-light text-dark",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("is_power"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-lg fa-plug" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("is_family") && _vm.property.is_family
            ? _c(
                "li",
                {
                  staticClass:
                    "feature badge bg-light text-dark position-relative",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("is_family"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-lg fa-children" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("is_furnished") && _vm.property.is_furnished
            ? _c(
                "li",
                {
                  staticClass:
                    "feature badge bg-light text-dark position-relative",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("is_furnished"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-lg fa-couch" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("is_kitchen") && _vm.property.is_kitchen
            ? _c(
                "li",
                {
                  staticClass:
                    "feature badge bg-light text-dark position-relative",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("is_kitchen"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-lg fa-sink" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("is_air_conditioners") &&
          _vm.property.is_air_conditioners
            ? _c(
                "li",
                {
                  staticClass:
                    "feature badge bg-light text-dark position-relative",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("is_air_conditioners"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-lg fa-snowflake" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("is_elevator") && _vm.property.is_elevator
            ? _c(
                "li",
                {
                  staticClass:
                    "feature badge bg-light text-dark position-relative",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("is_elevator"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-lg fa-elevator" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("is_parking") && _vm.property.is_parking
            ? _c(
                "li",
                {
                  staticClass:
                    "feature badge bg-light text-dark position-relative",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("is_parking"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-lg fa-square-parking" })]
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-4ad71fba_0", { source: "\n.icon{\n    width:10%;\n}\n.properties-img .image-holder{\n    display: block;\n    padding-top: 100%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n}\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/components/property-features-component.vue"],"names":[],"mappings":";AAyGA;IACA,SAAA;AACA;AACA;IACA,cAAA;IACA,iBAAA;IACA,4BAAA;IACA,sBAAA;IACA,2BAAA;AACA","file":"property-features-component.vue","sourcesContent":["<template>\r\n\t<ul v-if=\"property\" class=\"features g-0 d-flex justify-content-start gap-1 mb-2 pt-1\">\r\n        <li v-if=\"property['images'] && property['images'].length > 0\" class=\"feature badge bg-light text-dark\">\r\n            <i class=\"fa-solid fa-lg fa-images\"></i> {{property[\"images\"].length}}\r\n        </li>\r\n        <li v-if=\"check_enabled('size') && property.size > 0\" class=\"feature badge bg-light text-dark d-flex\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Size')\" data-bs-trigger=\"hover\">\r\n            <i class=\"ri-custom-size ri-xl mx-1\"></i> <span class=\"d-block\">{{ helper.t(\"{0} sq.m.\",[property['size'].toFixed(2).replace(/[.,]00$/, \"\")]) }}</span>\r\n        </li>\r\n        <li v-if=\"check_enabled('no_bed') && property.no_bed > 0\" class=\"feature badge bg-light text-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Bedrooms')\" data-bs-trigger=\"hover\">\r\n            <i class=\"fa-solid fa-lg fa-door-closed\"></i> {{property.no_bed}}\r\n        </li>\r\n        <li v-if=\"check_enabled('no_living') && property.no_living > 0\" class=\"feature badge bg-light text-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Livingrooms')\" data-bs-trigger=\"hover\">\r\n            <i class=\"fa-solid fa-lg fa-tv\"></i> {{property.no_living}}\r\n        </li>\r\n        <li v-if=\"check_enabled('no_bath') && property.no_bath > 0\" class=\"feature badge bg-light text-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Bathrooms')\" data-bs-trigger=\"hover\">\r\n            <i class=\"fa-solid fa-lg fa-bath\"></i> {{property.no_bath}}\r\n        </li>\r\n        <li v-if=\"check_enabled('is_water') && property.is_water\" class=\"feature badge bg-light text-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('is_water')\" data-bs-trigger=\"hover\">\r\n            <i class=\"fa-solid fa-lg fa-droplet\"></i>\r\n        </li>\r\n        <li v-if=\"check_enabled('is_power') && property.is_power\" class=\"feature badge bg-light text-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('is_power')\" data-bs-trigger=\"hover\">\r\n            <i class=\"fa-solid fa-lg fa-plug\"></i>\r\n        </li>\r\n        <li v-if=\"check_enabled('is_family') && property.is_family\" class=\"feature badge bg-light text-dark position-relative\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('is_family')\" data-bs-trigger=\"hover\">\r\n            <i class=\"fa-solid fa-lg fa-children\"></i>\r\n        </li>\r\n        <li v-if=\"check_enabled('is_furnished') && property.is_furnished\" class=\"feature badge bg-light text-dark position-relative\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('is_furnished')\" data-bs-trigger=\"hover\">\r\n            <i class=\"fa-solid fa-lg fa-couch\"></i>\r\n        </li>\r\n        <li v-if=\"check_enabled('is_kitchen') && property.is_kitchen\" class=\"feature badge bg-light text-dark position-relative\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('is_kitchen')\" data-bs-trigger=\"hover\">\r\n            <i class=\"fa-solid fa-lg fa-sink\"></i>\r\n        </li>\r\n        <li v-if=\"check_enabled('is_air_conditioners') && property.is_air_conditioners\" class=\"feature badge bg-light text-dark position-relative\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('is_air_conditioners')\" data-bs-trigger=\"hover\">\r\n            <i class=\"fa-solid fa-lg fa-snowflake\"></i>\r\n        </li>\r\n        <li v-if=\"check_enabled('is_elevator') && property.is_elevator\" class=\"feature badge bg-light text-dark position-relative\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('is_elevator')\" data-bs-trigger=\"hover\">\r\n            <i class=\"fa-solid fa-lg fa-elevator\"></i>\r\n        </li>\r\n        <li v-if=\"check_enabled('is_parking') && property.is_parking\" class=\"feature badge bg-light text-dark position-relative\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('is_parking')\" data-bs-trigger=\"hover\">\r\n            <i class=\"fa-solid fa-lg fa-square-parking\"></i>\r\n        </li>\r\n    </ul>\r\n</template>\r\n\r\n<script>\r\n    import * as global from \"../../js/global\" ;\r\n    import * as helper from \"../../js/helper\";\r\n    export default{\r\n        components: {\r\n        },\r\n\t\tname:'property_features_component',\r\n        props: {\r\n            property_json: {\r\n                type: String,\r\n            },\r\n            property_data: {\r\n                type: Object,\r\n            },\r\n        },\r\n\t\tdata() {\r\n\t\t\treturn {\r\n                global,\r\n                helper,\r\n                frappe,\r\n                is_loading: false,\r\n                property: null,\r\n\t\t\t};\r\n\t\t},\r\n        mounted(){\r\n            if(this.property_json != undefined)\r\n                this.property = JSON.parse(this.property_json);\r\n            else\r\n                this.property = this.property_data;\r\n        },\r\n\t\tmethods: {\r\n\t\t\tcheck_enabled: function(field){\r\n\t\t\t\tif (this.property.property_type==\"\")\r\n\t\t\t\t\treturn false;\r\n\t\t\t\treturn this.enabled_fields.includes(field);\r\n\t\t\t},\r\n\t\t},\r\n\t\tcomputed:{\r\n            enabled_fields(){\r\n                var fields = global.property_constants.property_types[this.property.property_type];\r\n                global.property_constants.remove_field[this.property.ad_type].forEach(field => {\r\n                    const index = fields.indexOf(field);\r\n                    if (index > -1) { // only splice array when item is found\r\n                        fields.splice(index, 1); // 2nd parameter means remove one item only\r\n                    }\r\n                });\r\n                if(this.is_child){\r\n                    global.property_constants.remove_child_field.forEach(field => {\r\n                        const index = fields.indexOf(field);\r\n                        if (index > -1) { // only splice array when item is found\r\n                            fields.splice(index, 1); // 2nd parameter means remove one item only\r\n                        }\r\n                    });\r\n                }\r\n                return fields;\r\n            }\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style>\r\n    .icon{\r\n        width:10%;\r\n    }\r\n    .properties-img .image-holder{\r\n        display: block;\r\n        padding-top: 100%;\r\n        background-repeat: no-repeat;\r\n        background-size: cover;\r\n        background-position: center;\r\n    }\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/components/property-features-component.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__